<template>
  <textarea
    v-model="model"
    :class="cn(textAreaVariants({ variant }), props.class ?? '')"
  />
</template>

<script setup>
import { useVModel } from '@vueuse/core';
import { cva } from 'class-variance-authority';
import { cn } from '../../utils.js';

const props = defineProps({
  class: {
    type: String,
    default: '',
  },
  defaultValue: {
    type: String,
    default: '',
  },
  modelValue: {
    type: String,
    default: '',
  },
  variant: {
    type: String,
    default: 'primary',
  },
});

const emit = defineEmits(['update:modelValue']);

const model = useVModel(props, 'modelValue', emit);

const textAreaVariants = cva(
  [
    'flex w-full rounded',
    'border',
    'ring-offset-neutral-900 focus:ring-2 focus:ring-offset-[0px] focus:ring-neutral-300/20',
    'px-3 py-2 text-sm',
    'file:border-0 file:bg-transparent file:text-sm file:font-medium',
    'disabled:cursor-not-allowed disabled:opacity-50',
    'text-neutral-300 placeholder:text-neutral-500 focus-visible:outline-none',
  ],
  {
    variants: {
      variant: {
        dark: ['bg-neutral-900 border-neutral-300 '],
        primary: ['bg-primary-700 hover:bg-primary-700/40 border-primary-400'],
      },
    },
    defaultVariants: {
      variant: 'primary',
    },
  }
);
</script>
